/**
 * Whether a panel's own step-by-step demo is on screen right now.
 *
 * Exists so the host's "close this window" hint can wait its turn. A tutorial
 * lesson arrives in a tool and asks for two things at once: the panel's
 * walkthrough, and the ✕ pulsing because the lesson's next step is the user
 * leaving. Both fired on entry, so the ✕ said "close this" while the
 * walkthrough was still saying "tap Generate" — two instructions, opposite
 * directions, on first sight of an unfamiliar tool.
 *
 * Module-level rather than context because the two sides are far apart in the
 * tree (a demo inside a panel, the ✕ on its chrome) and neither owns the other.
 */
let visibleCount = 0;
const listeners = new Set();

function notify() {
  listeners.forEach((fn) => fn(visibleCount > 0));
}

/** Called by `usePanelDemo` as a demo appears and goes. */
export function setPanelDemoVisible(visible) {
  visibleCount = Math.max(0, visibleCount + (visible ? 1 : -1));
  notify();
}

export function isPanelDemoVisible() {
  return visibleCount > 0;
}

export function subscribeToPanelDemoVisible(callback) {
  listeners.add(callback);
  callback(visibleCount > 0);
  return () => listeners.delete(callback);
}

/** Test-only: drop the module-level state between cases. */
export function __resetPanelDemoVisibility() {
  visibleCount = 0;
  listeners.clear();
}
